import { defineStore } from 'pinia'
import { reactive, computed } from 'vue'

interface ICMSLocationsStoreState {
	CMSLocations: ICMSLocationModel[] | null
	fetchingCMSLocations: boolean
	isFetching: Promise<boolean> | boolean
	fetchCMSLocationsPromise: Promise<ICMSLocationModel[]> | null
}

interface ICMSLocationsStore {
	readonly state: ICMSLocationsStoreState
	setCMSLocations: (CMSLocations: ICMSLocationModel[]) => void
	setFetchingCMSLocations: (fetching: boolean) => void
	getCMSLocations: ComputedRef<ICMSLocationModel[] | null>
	fetchCMSLocations: () => Promise<ICMSLocationModel[] | undefined>
	getFetchingCMSLocations: ComputedRef<boolean>
}

export const useCMSLocationsStore = defineStore('CMSLocationsStore', (): ICMSLocationsStore => {
	const { locale } = useI18n()
	const _state = reactive<ICMSLocationsStoreState>({
		CMSLocations: null,
		fetchingCMSLocations: false,
		isFetching: false,
		fetchCMSLocationsPromise: null,
	})

	const setCMSLocations = (CMSLocations: ICMSLocationModel[]): void => {
		_state.CMSLocations = CMSLocations
	}

	const setFetchingCMSLocations = (fetching: boolean): void => {
		_state.fetchingCMSLocations = fetching
	}

	const fetchCMSLocations = async () => {
		try {
			if (_state.CMSLocations && _state.CMSLocations.length > 0) {
				return _state.CMSLocations
			}

			if (_state.fetchCMSLocationsPromise) {
				return _state.fetchCMSLocationsPromise
			}

			_state.fetchCMSLocationsPromise = (async () => {
				const { data } = await ApiService.fetchAllCMSLocations(1, 200, '', false, undefined, false, locale.value)

				if (data && data.length > 0) {
					setCMSLocations(data)
				} else {
					setCMSLocations([])
				}

				return _state.CMSLocations as ICMSLocationModel[]
			})()

			return await _state.fetchCMSLocationsPromise
		} catch (error) {
			console.log(error)
		} finally {
			_state.fetchCMSLocationsPromise = null
		}
	}

	const getCMSLocations = computed(() => _state.CMSLocations)

	const getFetchingCMSLocations = computed(() => _state.fetchingCMSLocations)

	return {
		state: _state,
		setCMSLocations,
		setFetchingCMSLocations,
		fetchCMSLocations,
		getCMSLocations,
		getFetchingCMSLocations,
	}
})
